<script setup lang="ts">
import Select from 'primevue/select'
import MultiSelect from 'primevue/multiselect'

withDefaults(
    defineProps<{
        modelValue?: unknown
        options: Array<Record<string, unknown>> | unknown[]
        optionLabel?: string
        optionValue?: string
        placeholder?: string
        disabled?: boolean
        invalid?: boolean
        filter?: boolean
        showClear?: boolean
        multiple?: boolean
    }>(),
    {
        showClear: true,
        multiple: false
    }
)

defineEmits<{
    (e: 'update:modelValue', value: unknown): void
}>()
</script>

<template>
    <MultiSelect
        v-if="multiple"
        :model-value="$props.modelValue"
        :options="options"
        :option-label="optionLabel"
        :option-value="optionValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :invalid="invalid"
        :filter="filter"
        :show-clear="showClear"
        class="w-full"
        @update:model-value="$emit('update:modelValue', $event)"
    />
    <Select
        v-else
        :model-value="$props.modelValue"
        :options="options"
        :option-label="optionLabel"
        :option-value="optionValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :invalid="invalid"
        :filter="filter"
        :show-clear="showClear"
        @update:model-value="$emit('update:modelValue', $event)"
    />
</template>
